import React, { createContext, useContext, useMemo, useState } from "react";

const ProductCategoryContext = createContext();

export const useProductCategory = () => useContext(ProductCategoryContext);

export const ProductCategoryProvider = ({ children }) => {
  const [products, setProducts] = useState([]);

  const addProducts = (newProducts) => {
    setProducts((prev) => {
      const combined = [...prev, ...newProducts];
      const unique = Array.from(new Set(combined.map(p => p.id))).map(id =>
        combined.find(p => p.id === id)
      );
      return unique;
    });
  };

  const value = useMemo(() => ({
    products,
    addProducts
  }), [products, addProducts]);

  return (
    <ProductCategoryContext.Provider value={value}>
      {children}
    </ProductCategoryContext.Provider>
  );
};
